/**
 * useAttentionList (KAN-705, KAN-706, KAN-734)
 *
 * Rows of one view of the attention block for a channel. `showAll` asks for
 * up to ALL_LIMIT rows ("Показать все"), otherwise the backend default.
 * `enabled: false` keeps the cached data but does not fetch.
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import type { AttentionChannel, AttentionList } from '@/services/api/dashboard'
import { ATTENTION_VIEWS, type AttentionView } from './attentionViews'

/** Backend default page size and the "Показать все" size (KAN-705). */
export const DEFAULT_LIMIT = 20
export const ALL_LIMIT = 200

export function useAttentionList(
  view: AttentionView,
  channel: AttentionChannel,
  showAll: boolean,
  enabled = true
) {
  const config = ATTENTION_VIEWS[view]
  const limit = showAll ? ALL_LIMIT : DEFAULT_LIMIT
  const queryKey = [...config.queryKey, channel, limit] as const
  const query = useQuery<AttentionList>({
    queryKey,
    queryFn: () => config.fetch({ channel, limit: showAll ? ALL_LIMIT : undefined }),
    placeholderData: keepPreviousData,
    enabled,
  })
  return { ...query, queryKey }
}
